let map, totalMarkers, activeMarker = 1, mapExpanded = false,
    mapElement = document.querySelector(".js-map"),
    mapWrapper = document.querySelector(".js-map-wrapper"),
    artImage = document.querySelector(".js-art-image"),
    artImageWrapper = document.querySelector(".js-image-wrapper"),
    artTitle = document.querySelector(".js-art-title"),
    artArtist = document.querySelector(".js-art-artist"),
    artAjax = document.querySelector(".js-art-ajax"),
    nextMarker = document.querySelector(".js-next-marker"),
    prevMarker = document.querySelector(".js-prev-marker"),
    markerCounter = document.querySelector(".js-marker-counter"),
    mapToggleButton = document.querySelector(".js-map-toggle");

myMarker.prototype = new google.maps.OverlayView();

google.maps.event.addDomListener(window, "load", initialize);

function initialize() {
    let defaultLatLng = new google.maps.LatLng(53.79852174, -1.54205561);
    let bounds = new google.maps.LatLngBounds();
    const style = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":17}]}];

    let mapOptions = {
        zoom: 16,
        minZoom: 2,
        //maxZoom:18,
        center: defaultLatLng,
        disableDefaultUI: true,
        backgroundColor: "transparent",
        styles: style
    };

    map = new google.maps.Map(mapElement, mapOptions);

    // prod "/wp/wp-content/themes/artTrail/phpScripts/json.php",
    // local "/art-trail/wp-content/themes/artTrail/phpScripts/json.php",

    // MARKERS
    $.getJSON(
        "/art-trail/wp-content/themes/artTrail/phpScripts/json.php",
        function (data) {
            bounds = new google.maps.LatLngBounds();

            $.each(data, function (i, post) {
                let title = post.title;
                let location = post.location;
                let latitude = post.location.lat;
                let longitude = post.location.lng;
                let permalink = post.permalink;
                let artist = post.artist;
                let image = post.image;
                let number = post.number;

                let position = new google.maps.LatLng(latitude, longitude);
                bounds.extend(position);

                new myMarker(
                    position,
                    permalink,
                    title,
                    location,
                    artist,
                    image,
                    map,
                    number
                );
            });

            totalMarkers = data.length;
            map.fitBounds(bounds);
        }
    );
}

function myMarker(
    position,
    permalink,
    title,
    location,
    artist,
    image,
    map,
    number
) {
    this.position_ = position;
    this.permalink_ = permalink;
    this.title_ = title;
    this.artist_ = artist;
    this.location_ = location;
    this.image_ = image;
    this.number_ = number;
    this.map_ = map;
    this.div_ = null;
    this.setMap(map);
}

myMarker.prototype.draw = function () {
    const self = this;
    let div = this.div;

    let thisPos = this.position_;

    if (!div) {
        div = this.div = document.createElement("div");
        div.className = "marker";

        if (this.number_ == activeMarker) {
            div.className = "marker active marker" + this.number_;
        } else {
            div.className = "marker marker" + this.number_;
        }

        //div.style.backgroundImage = "url(" + this.image_ + ")";

        // const text = document.createTextNode(self.args.marker_title);
        // div.appendChild(text);

        google.maps.event.addDomListener(div, "click", function () {
            google.maps.event.trigger(self, "click");

            // marker active states
            let allMarkers = document.querySelectorAll(".marker");
            allMarkers.forEach((mrkr) => {
                mrkr.classList.remove("active");
            });
            div.classList.add("active");

            // update activemarker                       
            activeMarker = self.number_;            
            markerCounter.textContent = activeMarker;

            // pan toi marker and zoom if needed
            map.panTo(thisPos);
            if (map.getZoom() < 14) {
                map.setZoom(14);
            }

            //fade out image
            gsap.to(artImage, 0.3, {
                autoAlpha: 0,
                ease: Power1.easeInOut
            });
            // load inew image and fade back in when loaded
            if (self.image_) {
                artImage.src = self.image_;
                imagesLoaded(artImageWrapper, function () {
                    gsap.to(artImage, 0.3, {
                        autoAlpha: 1,
                        ease: Power1.easeInOut
                    });
                });
            }

            // update title
            artTitle.innerHTML = self.title_;

            // update artist
            if (self.artist_) {
                artArtist.innerHTML = "by " + self.artist_;
            } else {
                artArtist.innerHTML = "";
            }

            // ajax content
            gsap.set(artAjax, {
                autoAlpha: 0
            });
            $(artAjax).load(self.permalink_ + " #ajaxSource", function () {
                lazyLoad();
                gsap.to(artAjax, 0.3, {
                    autoAlpha: 1,
                    ease: Power1.easeInOut
                });
            });
            
        });

        const panes = this.getPanes();
        panes.overlayImage.appendChild(div);
    }

    const point = this.getProjection().fromLatLngToDivPixel(thisPos);

    if (point) {
        div.style.left = point.x - 10 + "px";
        div.style.top = point.y - 10 + "px";
    }
};


nextMarker.addEventListener("click", () => {
    activeMarker++;
    if (activeMarker > totalMarkers) {
        activeMarker = 1;
    }

    let newMarker = document.querySelector(".marker" + activeMarker);
    newMarker.click();
    //markerCounter.textContent = activeMarker;
});

prevMarker.addEventListener("click", () => {
    activeMarker--;
    if (activeMarker < 1) {
        activeMarker = totalMarkers;
    }

    let newMarker = document.querySelector(".marker" + activeMarker);
    newMarker.click();
    //markerCounter.textContent = activeMarker;
});


mapToggleButton.addEventListener("click", () => {
    mapExpanded = !mapExpanded;

    if (mapExpanded) {
        mapWrapper.classList.add('is-expanded');
        mapToggleButton.classList.add('is-expanded');
    } else {
        mapWrapper.classList.remove('is-expanded');
        mapToggleButton.classList.remove('is-expanded');
    }
    
});
